/* @flow weak */
// Event Tracking Screen Names

// Payment Request Flow
const GET_STARTED_SCREEN = 'collect_get_started';
const SET_AMOUNT_SCREEN = 'collect_set_amount';
const LINK_SCREEN = 'collect_link';

// Activity Creation Flow
const ACTIVITY_GET_STARTED = 'activity_get_started';
const CREATE_ACTIVITY_FORM = 'create_activity_form';
const CURRENT_ACTIVITIES = 'current_activities';
const CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG = 'create_activity_form_universal_dialog';
const CREATE_ACTIVITY_COMPOSER_UNIVERSAL_DIALOG = 'create_activity_composer_universal_dialog';

// Activity Component
const ACTIVITY_COMPONENT = 'activity_component';
const REMOVE_ACTIVITY_MODAL = 'remove_activity_modal';

// Class Feed
const MESSAGE_PAYMENT = 'pay';
const MESSAGE_PAYMENT_LINK = 'payment_link';

// Event Participation View
const RSVP = 'rsvp';

// Payment Flow
const SELECT_PAYMENT = 'select_payment';
const CONFIRM_PAYMENT = 'confirm_payment';
const PAYMENT_RECEIPT = 'payment_receipt';
const PAYMENT_LOGIN = 'payment_login';

// Campaigns Page
const YOUR_CAMPAIGN_PAYMENTS = 'your_campaign_payments';

// Link School Bank Account Flow
const TREASURER_INTERSTITIAL = 'treasurer_interstitial';
const TREASURER_ADD_BANK_ACCOUNT = 'treasurer_add_bank_account';

// Cash Out Flow
const CREATE_DEPOSIT_ADDRESS = 'create_deposit_address';
const CREATE_DEPOSIT_ACCOUNT = 'create_deposit_account';
const CONFIRM_DEPOSIT = 'confirm_deposit';
const DEPOSIT_RECEIPT = 'deposit_receipt';
const DEPOSIT_SELECT = 'deposit_select';

export default {
  ACTIVITY_COMPONENT,
  ACTIVITY_GET_STARTED,
  CONFIRM_DEPOSIT,
  CONFIRM_PAYMENT,
  CREATE_ACTIVITY_FORM,
  CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
  CREATE_ACTIVITY_COMPOSER_UNIVERSAL_DIALOG,
  CREATE_DEPOSIT_ACCOUNT,
  CREATE_DEPOSIT_ADDRESS,
  CURRENT_ACTIVITIES,
  DEPOSIT_RECEIPT,
  DEPOSIT_SELECT,
  GET_STARTED_SCREEN,
  LINK_SCREEN,
  MESSAGE_PAYMENT_LINK,
  MESSAGE_PAYMENT,
  PAYMENT_LOGIN,
  PAYMENT_RECEIPT,
  REMOVE_ACTIVITY_MODAL,
  RSVP,
  SELECT_PAYMENT,
  SET_AMOUNT_SCREEN,
  TREASURER_ADD_BANK_ACCOUNT,
  TREASURER_INTERSTITIAL,
  YOUR_CAMPAIGN_PAYMENTS,
};



// WEBPACK FOOTER //
// ./src/payments/constants/EventTrackingConstants.js